<template>
	<div>
		<vs-card>
			<b-row>
				<h4 class="text-primary">
					<div>
						<vs-chip class="mr-3" :color="CollectionIsDone == true ? 'success' : 'danger'">{{
							CollectionIsDone == true ? $t("Complete") : $t("NotComplete")
						}}</vs-chip>
					</div>
					{{ $t("CompanyName") }} : {{ CompanyName }} - {{ $t("CollectionCode") }} :
					{{ CollectionCode }}
				</h4>
			</b-row>
			<vs-divider></vs-divider>

			<b-row>
				<b-col lg="5">
					<b-row>
						<b-col lg="3" style="text-align: start" align-self="center">
							<b-form-group style="font-size: medium" :label="'* ' + $t('Barcode')" label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label-for="item-name">
								<b-form-input id="barcodeId" ref="barcodeId" v-model="stockno" :placeholder="$t('Stockno')"
									@keyup.enter="scanBarcode" @input="stockNoValidate" />
							</b-form-group>
						</b-col>
					</b-row>
				</b-col>
				<b-col lg="3">
					<b-row>
						<b-col lg="5" style="text-align: start" align-self="center">
							<b-form-group style="font-size: medium" :label="'* ' + $t('Quantity')" label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label-for="item-name">
								<b-form-input id="quantityManuel" ref="quantityManuel" v-model="quantityManuel"
									:placeholder="$t('Quantity')" v-validate="'required|decimal'" name="quantityManuel" />
								<span class="text-danger text-sm" v-if="errors.has('quantityManuel')">{{
									errors.first("quantityManuel")
								}}</span>
							</b-form-group>
						</b-col>
					</b-row>
				</b-col>
				<b-col class="items-center">
					<b-row align-h="start">
						<b-col cols="3" md="auto">
							<b-button class="bg-primary" style="border-color: white" :disabled="CollectionIsDone"
								v-on:click="submitData()">
								<Icon icon="fluent-mdl2:completed" width="20" height="20" />
								{{ $t("CompleteProcess") }}
							</b-button>
						</b-col>
						<b-col cols="3" md="auto">
							<b-button class="bg-warning" style="border-color: white"
								v-on:click="excelStock('OrderPickingList', allProductList)">
								<Icon icon="icon-park-outline:excel" style="margin-right: 5px" width="20" height="20" />{{ $t("Excel")
								}}
							</b-button>
						</b-col>
						<b-col cols="3" md="auto">
							<b-button class="bg-primary" style="border-color: white"
								v-on:click="printStock('OrderPickingList', allProductList)">
								<Icon icon="material-symbols:print-outline-rounded" style="margin-right: 5px" width="20" height="20" />
								{{ $t("Print")
								}}
							</b-button>
						</b-col>
					</b-row>
				</b-col>

			</b-row>
		</vs-card>
		<component :is="scrollbarTag" ref="scroll" class="vs-input--label scroll-area--data-list-add-new"
			:settings="settings" :key="$vs.rtl">
			<template lang="html">
				<div ref="printablepickingorder">
					<vs-card>
						<vs-table v-model="selected" @selected="handleSelected" :data="allProductList">
							<template slot="thead">
								<vs-th sort-key="MarketPlaceName">{{ $t("MarketPlaceName") }} </vs-th>
								<vs-th sort-key="OrderNumber">{{ $t("OrderNumber") }}</vs-th>
								<vs-th sort-key="MarketPlaceSku">{{ $t("MarketPlaceSku") }}</vs-th>
								<vs-th sort-key="MarketPlaceBarcode">{{ $t("MarketPlaceBarcode") }}</vs-th>
								<vs-th sort-key="CorridorCode">{{ $t("CorridorCode") }}</vs-th>
								<vs-th sort-key="ShelfCode">{{ $t("ShelfCode") }}</vs-th>
								<vs-th sort-key="OrderItemQuantity">{{ $t("OrderItemQuantity") }}</vs-th>
								<vs-th sort-key="OrderItemReadQuantity">{{
									$t("OrderItemReadQuantity")
								}}</vs-th>
								<vs-th sort-key="actions">{{ $t("actions") }}</vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
									<vs-td :data="data[indextr].MarketPlaceName">
										{{ data[indextr].MarketPlaceName }}
									</vs-td>
									<vs-td :data="data[indextr].OrderNumber">
										{{ data[indextr].OrderNumber }}
									</vs-td>
									<vs-td :data="data[indextr].MarketPlaceSku">
										{{ data[indextr].MarketPlaceSku }}
									</vs-td>
									<vs-td :data="data[indextr].MarketPlaceBarcode">
										{{ data[indextr].MarketPlaceBarcode }}
									</vs-td>
									<vs-td :data="data[indextr].CorridorCode">
										{{ data[indextr].CorridorCode }}
									</vs-td>
									<vs-td :data="data[indextr].ShelfCode">
										{{ data[indextr].ShelfCode }}
									</vs-td>
									<vs-td :data="data[indextr].OrderItemQuantity">
										{{ data[indextr].OrderItemQuantity }}
									</vs-td>
									<vs-td :data="data[indextr].OrderItemReadQuantity">
										<vs-chip :color="data[indextr].OrderItemQuantity ==
											data[indextr].OrderItemReadQuantity
											? 'success'
											: 'warning'
											">
											{{ data[indextr].OrderItemReadQuantity }}
										</vs-chip>
									</vs-td>
									<vs-td>
										<b-row>
											<b-button class="bg-primary" style="border-color: white" size="sm" :disabled="CollectionIsDone"
												v-on:click="scanBarcode(-1, indextr)">
												{{ $t("Reduce") }}
											</b-button>
										</b-row>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</vs-card>
				</div>

			</template>
		</component>
	</div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Icon } from "@iconify/vue2";
import { Validator } from "vee-validate";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";

export default {
	components: {
		Icon,
		VuePerfectScrollbar,
	},
	data() {
		return {
			quantityManuel: 1,
			CollectionCode: "",
			CompanyName: "",
			CollectionIsDone: "",
			submitDataValidate: false,
			stockno: "",
			selected: [],

			allProductList: [],
			paramCollection: [],
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	methods: {
		printStock() {
			const printContents = this.$refs.printablepickingorder.innerHTML;
			const originalContents = document.body.innerHTML;

			const printWindow = window.open("", "", "height=600,width=800");
			printWindow.document.write("<html><head><title>Print</title>");
			printWindow.document.write("</head><body >");
			printWindow.document.write(printContents);
			printWindow.document.write("</body></html>");
			printWindow.document.close();
			printWindow.print();
		},
		excelStock(baslik, dataLc) {
			const data = dataLc.map(({ OrdersItemCollectionId, CollectionIsDone, CompanyId, ...rest }) => rest);

			const worksheet = XLSX.utils.json_to_sheet(data);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

			const excelBuffer = XLSX.write(workbook, {
				bookType: "xlsx",
				type: "array",
			});

			// Excel dosyasını kaydetme
			const blob = new Blob([excelBuffer], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});
			let today = this.parseDate(new Date());

			saveAs(blob, baslik + today + ".xlsx");
		},
		parseDate(params) {
			return moment(String(params)).format("DD.MM.YYYY");
		},
		stockNoValidate() {
			this.stockno = this.stockno.replace(/\?/g, "_").replace(/ı/g, "i");
		},
		submitData() {
			var vs = this.$vs;

			let obj = [];

			this.allProductList.forEach((val, index) => {
				obj.push({
					ordersItemCollectionId: val.OrdersItemCollectionId,
					orderNumber: val.OrderNumber,
					marketPlaceName: val.MarketPlaceName,
					marketPlaceSku: val.MarketPlaceSku,
					marketPlaceBarcode: val.MarketPlaceBarcode,
					marketPlaceCargoName: val.MarketPlaceCargoName,
					orderItemQuantity: val.OrderItemQuantity,
					orderItemReadQuantity: val.OrderItemReadQuantity,
					shelfCode: val.ShelfCode,
					corridorCode: val.CorridorCode,
					collectionCode: val.CollectionCode,
					collectionIsDone: true,
					companyId: val.CompanyId,
					companyName: val.CompanyName,
				});
			});
			this.$store
				.dispatch("order/completeOrderColect", obj)
				.then((response) => {
					if (response.status == 200) {
						try {
							this.stockno = "";
							this.submitDataValidate = true;
							setTimeout(() => {
								document.getElementById("barcodeId").focus();
							}, 500);
							vs.notify({
								text: response.data.message.toString(),
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							this.getOrderCollectList();
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: this.$t("BeSureAllList") + response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		scanBarcode(isDue, index) {
			var vs = this.$vs;
			let indexBarcode = 0;
			if (isDue == -1) indexBarcode = index;
			else
				indexBarcode = this.allProductList.findIndex(
					(item) =>
						(item.MarketPlaceBarcode.trim() == this.stockno.trim() ||
							item.MarketPlaceSku.trim() == this.stockno.trim()) &&
						parseFloat(item.OrderItemQuantity) != parseFloat(item.OrderItemReadQuantity)
				);
			if (indexBarcode == -1) {
				vs.notify({
					text: this.$t("NotInList"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning",
					position: "top-center",
				});
			} else if (
				this.allProductList[indexBarcode].OrderItemQuantity ==
				this.allProductList[indexBarcode].OrderItemReadQuantity &&
				isDue != -1
			) {
				vs.notify({
					text: this.$t("GreaterThanQuantity"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning",
					position: "top-center",
				});
			} else {
				if (this.quantityManuel > this.allProductList[indexBarcode].OrderItemQuantity) {
					vs.notify({
						text: this.$t("GreaterThanQuantity"),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center",
					});
				} else {
					let collectMethod = "updatetOrderCollectQuantity";
					let obj = {
						orderCollecionId: this.allProductList[indexBarcode].OrdersItemCollectionId,
						barcode: this.stockno,
						quantity: this.quantityManuel,
					};
					if (isDue == -1) {
						collectMethod = "updatetOrderCollectQuantityDown";
						obj = {
							orderCollecionId: this.allProductList[indexBarcode].OrdersItemCollectionId,
							barcode: this.allProductList[indexBarcode].MarketPlaceBarcode,
							quantity: this.quantityManuel,
						};
					}
					this.$store
						.dispatch("order/" + collectMethod, obj)
						.then((response) => {
							if (response.status == 200) {
								try {
									this.stockno = "";
									setTimeout(() => {
										document.getElementById("barcodeId").focus();
									}, 500);
									vs.notify({
										text: response.data.message.toString(),
										iconPack: "feather",
										icon: "icon-alert-circle",
										color: "success",
										position: "top-center",
									});
									this.getOrderCollectList();
								} catch (error) {
									console.log(error);
								}
							} else
								vs.notify({
									text: response.data.message.toString(),
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "danger",
									position: "top-center",
								});
						})
						.catch((error) => {
							console.log(error);
							return new Promise((resolve, reject) => {
								resolve(false);
							});
						});
				}
			}
		},
		handleSelected(tr) { },
		getOrderCollectList() {
			var vs = this.$vs;

			this.$store
				.dispatch("order/listOrderCollectDetail", this.paramCollection)
				.then((response) => {
					if (response.success == true) {
						try {
							this.allProductList = JSON.parse(response.json);
							this.CollectionCode = this.allProductList[0].CollectionCode;
							this.CollectionIsDone = this.allProductList[0].CollectionIsDone;
							this.CompanyName = this.allProductList[0].CompanyName;
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
	},
	created() {
		// URL: /inventory-movements?productId=45&type=entry
		// URL: /inventory-movements/45
		Validator.extend("decimal", {
			validate: (value) => {
				return /^[0-9]*\.?[0-9]+$/.test(value); // Ondalık veya tam sayıyı kontrol eden regex
			},
			message: "Lütfen geçerli bir sayı giriniz.", // Hata mesajı
		});
		this.paramCollection = this.$route.params.collection;
		this.getOrderCollectList();
		setTimeout(() => {
			document.getElementById("barcodeId").focus();
		}, 1000);
	},
	computed: {
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
	},
	mounted() {
		setTimeout(() => {
			this.$refs.barcodeId.focus();
		}, 1000);
	},
};
</script>
<style lang="scss" scoped>
.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 110px);

	&:not(.ps) {
		overflow-y: auto;
	}
}
</style>
